module.exports = __webpack_public_path__ + "media/images/collapse-arrow-74a460d7e96df83148eab77a67aa0ec1.png";